import {createContext} from "react";

const QueryContext = createContext(undefined);
export default QueryContext;